import {WIX_ECOM} from '@wix/app-definition-ids';
import {PageMap} from '@wix/wixstores-client-core/dist/src/constants';
import {EditorSDK, PageRef} from '@wix/platform-editor-sdk';
import {ExperimentsApi} from '../../common/experiments/ExperimentsApi';
import {PageData} from '@wix/editor-platform-sdk-types';

export async function getEcomPages(sdk: EditorSDK) {
  const isRemoveDeprecatedAppIdExperimentEnabled = ExperimentsApi.isOnlineStoresRemoveDeprecatedAppIdExperimentEnabled;
  if (!isRemoveDeprecatedAppIdExperimentEnabled) {
    const ecomApplicationId = (await sdk.tpa.app.getDataByAppDefId('', WIX_ECOM)).applicationId;
    const allSitePages = await sdk.pages.data.getAll('');
    return allSitePages.filter((page) => page.tpaApplicationId === ecomApplicationId);
  }
  const allSitePages = await sdk.pages.data.getAll('');
  return allSitePages.filter((page) => page.appDefinitionId === WIX_ECOM);
}

export async function getShopPagesTpaPageId(sdk: EditorSDK) {
  const ecomPages = await getEcomPages(sdk);
  const shopPages = ecomPages.filter((page) => page.tpaPageId?.startsWith(PageMap.GALLERY));
  return shopPages.map((x) => x.tpaPageId);
}

export async function getProductPage(sdk: EditorSDK) {
  const ecomPages = await getEcomPages(sdk);
  return ecomPages.find(
    (page) =>
      page.tpaPageId === PageMap.PRODUCT ||
      (page.tpaPageId !== PageMap.PRODUCT_PAGE_VARIANT && page.tpaPageId?.startsWith(PageMap.PRODUCT))
  );
}

export async function getCategoryPage(sdk: EditorSDK) {
  const ecomPages = await getEcomPages(sdk);
  return ecomPages.find(
    (page) =>
      page.tpaPageId === PageMap.CATEGORY ||
      (page.tpaPageId !== PageMap.CATEGORY_PAGE_VARIANT && page.tpaPageId?.startsWith(PageMap.CATEGORY))
  );
}

export async function getNumOfPagesByTpaPageId(sdk: EditorSDK, tpaPageId: PageMap) {
  const ecomPages = await getEcomPages(sdk);
  const pages = ecomPages.filter((page) => page.tpaPageId === tpaPageId);
  return pages.length;
}

export async function checkIfPageExists(sdk: EditorSDK, page: PageMap) {
  const ecomPagesData = await getEcomPages(sdk);
  return !!ecomPagesData.find((p) => p.tpaPageId === page);
}

export async function hasCategoryPageOnSite(sdk: EditorSDK) {
  const ecomPages = await getEcomPages(sdk);
  return !!ecomPages.find((page) => page.tpaPageId?.startsWith(PageMap.CATEGORY));
}

export async function updateTpaPageIdIfNeeded(sdk: EditorSDK, tpaPageId: PageMap) {
  let page: PageData = null;
  if (tpaPageId === PageMap.PRODUCT) {
    page = await getProductPage(sdk);
  } else if (tpaPageId === PageMap.CATEGORY) {
    page = await getCategoryPage(sdk);
  }

  if (page?.tpaPageId !== tpaPageId) {
    await sdk.pages.data.update('', {
      pageRef: {id: page?.id, type: 'DESKTOP'} as PageRef,
      data: {
        tpaPageId,
      },
    });
  }
}
